import {
  IWorkspaceProvisioningTask,
  RootCollection,
  WorkspaceProvisioningTaskStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  asColRef,
  AtLeast,
  CollectionReference,
} from '@principle-theorem/shared';

export class WorkspaceProvisioningTask {
  static init(
    overrides: AtLeast<IWorkspaceProvisioningTask, 'clickUp' | 'practiceName'>
  ): IWorkspaceProvisioningTask {
    return {
      status: WorkspaceProvisioningTaskStatus.Pending,
      deleted: false,
      ...overrides,
    };
  }

  static col(): CollectionReference<IWorkspaceProvisioningTask> {
    return asColRef<IWorkspaceProvisioningTask>(
      RootCollection.WorkspaceProvisioningTasks
    );
  }
}
